import { render, staticRenderFns } from "./contract.item.record.detail.vue?vue&type=template&id=7f84ed98&scoped=true&"
import script from "./contract.item.record.detail.vue?vue&type=script&lang=js&"
export * from "./contract.item.record.detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f84ed98",
  null
  
)

export default component.exports